module.exports={TICKET:{STARTING_FROM:"Tickets kaufen"}};